import { useState } from "react";
import { Check, Sparkles } from "lucide-react";
import { toast } from "sonner";

export const AgentText = ({ m }) =>
  m.type === "user" ? (
    <div className="flex justify-end"><p className="bubble-me max-w-[82%] rounded-[20px] rounded-br-[8px] px-4 py-2.5 text-[14px] leading-snug">{m.text}</p></div>
  ) : (
    <div className="flex items-end gap-2">
      <span className="grid h-7 w-7 shrink-0 place-items-center rounded-full bg-gradient-to-br from-[#7866E8] to-[#80D9EB] text-white"><Sparkles size={13} aria-hidden /></span>
      <p className="bubble-them max-w-[80%] rounded-[20px] rounded-bl-[8px] px-4 py-2.5 text-[14px] leading-snug">{m.text}</p>
    </div>
  );

export const AgentOptions = ({ items, joined, onExplore, onJoin }) => (
  <div className="space-y-2 pl-9">
    {items.map((it) => (
      <div key={it.id} className="glass glass-dark flex items-center gap-3 rounded-[20px] p-2.5" data-testid={`agent-option-${it.id}`}>
        <img src={it.image} alt="" className="h-14 w-11 shrink-0 rounded-xl object-cover" />
        <div className="min-w-0 flex-1">
          <p className="truncate text-[13.5px] font-semibold text-white">{it.title}</p>
          <p className="text-[11.5px] text-white/60">{it.meta}</p>
        </div>
        {it.kind === "join" && joined ? (
          <span className="flex items-center gap-1 text-[11.5px] font-semibold text-[#A5E6E3]" data-testid="agent-join-result"><Check size={13} /> Joined — sample</span>
        ) : (
          <button type="button" onClick={() => (it.kind === "join" ? onJoin() : onExplore(it))} data-testid={`agent-option-${it.id}-cta`} className="h-8 shrink-0 rounded-full bg-white/90 px-3.5 text-[12px] font-semibold text-[#14151B] hover:bg-white">
            {it.cta}
          </button>
        )}
      </div>
    ))}
  </div>
);

export const AgentInvite = ({ m }) => {
  const [state, setState] = useState("draft");
  const [text, setText] = useState(m.text);
  const approve = () => {
    setState("sent");
    toast("Invitation sent with your approval", { description: "Sample demo — nothing was actually sent." });
  };
  return (
    <div className="glass glass-dark ml-9 rounded-[22px] p-3.5" data-testid="agent-invite-card" data-state={state}>
      <div className="flex items-center gap-2">
        <img src={m.avatar} alt="" className="h-7 w-7 rounded-full object-cover" />
        <p className="text-[12px] font-semibold text-white">Draft invitation · To {m.to}</p>
      </div>
      {state === "editing" ? (
        <textarea value={text} onChange={(e) => setText(e.target.value)} rows={3} data-testid="agent-invite-textarea" aria-label="Edit invitation" className="mt-2.5 w-full resize-none rounded-2xl border border-white/15 bg-white/[0.07] p-2.5 text-[13px] text-white focus:border-[#A79DE2]/60 focus:outline-none" />
      ) : (
        <p className={`mt-2.5 text-[13px] leading-snug ${state === "cancelled" ? "text-white/55 line-through" : "text-white/85"}`}>{text}</p>
      )}
      {state === "draft" && (
        <>
          <button type="button" onClick={approve} data-testid="agent-approve-button" className="mt-3 h-10 w-full rounded-full bg-white/90 text-[13px] font-semibold text-[#14151B] hover:bg-white">Approve Invitation</button>
          <div className="mt-2 grid grid-cols-2 gap-2">
            <button type="button" onClick={() => setState("editing")} data-testid="agent-edit-button" className="h-9 rounded-full bg-white/10 text-[12.5px] font-semibold text-white hover:bg-white/15">Edit</button>
            <button type="button" onClick={() => setState("cancelled")} data-testid="agent-cancel-button" className="h-9 rounded-full bg-white/10 text-[12.5px] font-semibold text-white hover:bg-white/15">Cancel</button>
          </div>
          <p className="mt-2 text-center text-[10.5px] text-white/55">Nothing is sent without your approval.</p>
        </>
      )}
      {state === "editing" && (
        <button type="button" onClick={() => setState("draft")} data-testid="agent-save-button" className="mt-2 h-9 w-full rounded-full bg-white/90 text-[12.5px] font-semibold text-[#14151B]">Save draft</button>
      )}
      {state === "sent" && (
        <p className="mt-3 flex items-center gap-1.5 text-[12.5px] font-semibold text-[#A5E6E3]" data-testid="agent-invite-result" role="status"><Check size={14} /> Invitation sent with your approval — sample demo</p>
      )}
      {state === "cancelled" && (
        <div className="mt-3 flex items-center justify-between" role="status" data-testid="agent-invite-cancelled">
          <p className="text-[12px] text-white/60">Cancelled — nothing was sent.</p>
          <button type="button" onClick={() => setState("draft")} data-testid="agent-restore-button" className="text-[12px] font-semibold text-[#A79DE2]">Restore draft</button>
        </div>
      )}
    </div>
  );
};
